import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import Confirmation from '../../components/Confirmation/Confirmation'
import CustomSelect from '../../components/CustomSelect'
import { getSchoolYears } from '../../actions/common'
import { arrayForSelect } from '../../utils/arrayForSelect'
import moment from 'moment'
import { deleteTvProgramSchedule, getTvProgramSchedule } from '../../actions/tvProgramSchedule copy'

// Функция для получения первого понедельника августа
function getFirstMondayOfAugust(year) {
  const firstAugust = moment({ year, month: 7, date: 1 });
  const dayOfWeek = firstAugust.day();
  const daysToAdd = (8 - dayOfWeek) % 7;
  return firstAugust.add(daysToAdd, 'days');
}

function generateWeekArray(startYear) {
  const startMonday = getFirstMondayOfAugust(startYear);
  const endMonday = getFirstMondayOfAugust(+startYear + 1);
  const weeks = [];
  let currentMonday = startMonday.clone();
  let weekId = 1
  while (currentMonday.isBefore(endMonday)) {
    const weekStart = currentMonday.clone();
    const weekEnd = currentMonday.clone().add(6, 'days');
    weeks.push({
      week: `${weekStart.format('DD.MM')} - ${weekEnd.format('DD.MM')}`,
      begdate: weekStart.format('YYYY-MM-DD'),
      enddate: weekEnd.format('YYYY-MM-DD'),
      id: weekId++
    });
    currentMonday.add(7, 'days');
  }
  return weeks;
}


export default function TvProgramSchedule() {
  const dispatch = useDispatch()

  const { list } = useSelector(state => state.tv_program_schedule)
  const { schoolYears } = useSelector(state => state.common)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);
  const [filters, setFilters] = useState({});
  const [weeksList, setWeeksList] = useState([]); // список недель
  const [datesWeek, setDatesWeek] = useState(null);// для запросов создание\редактирование Даты недели 
  const [weekDay, setWeekDay] = useState([]);
  const [arrWeekProgram, setArrWeekProgram] = useState([]);
  const [newTime, setNewTime] = useState([]);


  useEffect(() => {
    dispatch(getSchoolYears())
  }, [])

  useEffect(() => {
    if (!filters.year) return
    const selectedYear = moment(schoolYears.find(({ xp_key }) => xp_key === filters.year)?.begdate).format('YYYY')
    setWeeksList(generateWeekArray(selectedYear))
  }, [filters.year])

  useEffect(() => {
    if (!filters.week) return
    setDatesWeek(weeksList?.find(({ id }) => id === filters.week))
    // dispatch(getTvProgramSchedule(datesWeek))
  }, [filters.week])

  useEffect(() => {
    if (!datesWeek) return
    // dispatch(getTvProgramSchedule(datesWeek))
    setWeekDay(setWeek(datesWeek))
    // list && setArrWeekProgram(setArrWeek(list))
  }, [datesWeek])

  useEffect(() => {
    if (!datesWeek) return
    dispatch(getTvProgramSchedule(datesWeek))
    setWeekDay(setWeek(datesWeek))
    // list && setArrWeekProgram(setArrWeek(list))
  }, [datesWeek])

  useEffect(() => {
    if (!list) return
    setArrWeekProgram(setArrWeek(list, weekDay))
  }, [list])

  const setWeek = (datesWeek) => {
    let arr = []
    const start = datesWeek.begdate
    const end = datesWeek.enddate
    for (let i = start; i <= end; i = moment(i).add(1, 'days').format('YYYY-MM-DD')) {
      arr.push({ date: moment(i).format('DD'), day: moment(i).format('dddd'), date_part: moment(i).format('YYYY-MM-DD') })
    }
    return arr
  }

  // строка на неделю со временем === массив строк со временем и датами
  const setArrWeek = (list, weekDay) => {
    // массив уникального времени в котором есть время и есть заполненные или пустые элементы с датой недели 
    const arrWeekProgram = list?.reduce((acc, item) => {
      if (!acc.find((el) => el.time_part === item.time_part)) {
        const newItem = weekDay?.map(({ date_part }) => date_part === item.date_part ? item : { date_part, time_part: item.time_part, name: '' })
        acc.push(newItem)
      }
      return acc
    }, [])
    return arrWeekProgram
  }


  const setFieldValue = (name, value) => {
    setFilters({ ...filters, [name]: value })
  }
  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)


  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteTvProgramSchedule(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };
  const handleSelectTime = (e) => {
    setNewTime(e.target.value)
  }

  const renderLi = (data) => {
    const { date, day, hour, name, time_part } = data
    return (
      <>
        <td onDoubleClick={openModal(data)} style={selectedItem === date ? { backgroundColor: 'aliceblue' } : { cursor: 'pointer' }}>{name}</td>
      </>
    )
  }

  const addNewWeek = () => {
    setArrWeekProgram(prev => [...prev, weekDay])
  }

  return (
    <div className={styles.wrapper} style={{ width: '900px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          height={'430px'}
          // addMode={(!selectedItem?.name && selectedItem !== null)}
          addMode={!selectedItem.id}
          filters={datesWeek}
          newTime={newTime}
        />
      }
      <h1>Расписание программ</h1>
      <CustomSelect
        title='Год'
        valuesName="year"
        value={filters.year}
        options={schoolYears && arrayForSelect(schoolYears, 'name', 'xp_key')}
        width={300}
        setFieldValue={setFieldValue}
      />
      <CustomSelect
        title='Неделя'
        valuesName="week"
        options={weeksList && arrayForSelect(weeksList, 'week', 'id')}
        width={300}
        value={filters.week}
        setFieldValue={setFieldValue}
      />
      <Table className={styles.tables}>
        <thead>
          <tr>
            <th></th>
            {/* {meal?.map(renderHeader)} */}
            {weekDay && weekDay?.map(({ date, day }) => <th key={date}>{` ${day} ${date}`}</th>)}
          </tr>
        </thead>
        <tbody>
          {/* <tr style={{ height: '30px' }}> */}
          {arrWeekProgram && arrWeekProgram.map(row =>
            <tr>
              <td onClick={handleSelectTime}>
                <input type={'time'} value={row[0]?.time_part?.slice(0, 5)} onChange={(e) => handleSelectTime(e)} />
              </td>
              {row.map(renderLi)}
            </tr>
          )}
          {/* </tr> */}
        </tbody>
      </Table>

      <div style={{ display: 'flex', flexDirection: "row" }}>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={addNewWeek}
        >
          <IoIosAdd size={30} />
          Добавить
        </Button>
      </div>
    </div>
  )
}
